import { render, staticRenderFns } from "./RoleItem.vue?vue&type=template&id=369e24d4"
import script from "./RoleItem.vue?vue&type=script&lang=js"
export * from "./RoleItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports